export default __webpack_public_path__ + "static/media/powered-by-listen-notes-white.5d42c9bb.png";